@if (utskriftsRapport()) {
<div class="mb-2">
    <h4 class="mb-0 mt-0">{{utskriftsRapport().rubrik}}</h4>
    <div
        class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center">
        <div class="d-flex align-items-center me-3">
            <rask-button
                [ngClass]="{'static-width-button': utskriftsRapport().staticWidthButton}"
                class="me-2"
                color="secondary"
                (click)="onSkapaUtskrifter()"
                [disabled]="skapaUtskrifterDisabled()"
                >
                Skapa
            </rask-button>
            @if (loading()) {
            <i
                class="fas fa-spinner fa-spin text-secondary">
            </i>
            }
            <rask-virkeskop-validation-icon-popover
                [context]="errorContext">
                @if (avtalDirty()) {
                <span #message>Kontraktet måste vara sparat för att skapa utskrifter</span>
                }
            </rask-virkeskop-validation-icon-popover>

        </div>
        @if (utskrift$ | async; as utskrift) {
        <div class="senaste-utskrifter ms-0 ms-lg-3">
            <div class="utskrift-item">
                @if (!loading()) {
                <div>
                    <div class="d-flex align-items-center">
                        <i class="far fa-file-pdf link-secondary"></i>
                        <a href="javascript:void(0)"
                            (click)="openDokument(utskrift)">
                            {{utskrift.dokumentNamn}}
                        </a>
                        <a href="javascript:void(0)" (click)="downloadDokument(utskrift)"
                            class="btn btn-lg btn-icon" title="Ladda ner dokumentet">
                            <span class="fas fa-download fa-xs"></span>
                        </a>
                        <br />
                    </div>
                    <div>
                        <span class="text-muted">
                            Version {{ utskrift.version }}, {{utskrift.skapadTid | date}}
                        </span>
                    </div>
                </div>
                }
            </div>
        </div>
        }
    </div>
</div>
}